import {colors} from "@material-ui/core";


export const styles = theme => ({
    container: {
        display: 'flex',
        flex: 1,
        flexGrow: 1,
        position: 'relative',
    },
    velocimetro: {
        border: '0 !important',
        padding: 6,
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        maxWidth: '100%',
        overflowX: 'hidden',
        opacity: '1 !important',
        [theme.breakpoints.up('sm')]: {
            maxWidth: '50%',
        },
        position: 'relative',
        '& .highcharts-background': {
            display: 'none'
        },
        '& .highcharts-container': {
            position: 'relative',
            maxWidth: '100%',
            flex: 1
        }
    },
    velocimetroPaper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flex: 1,
        padding: 5,
        border: '0 !important',
        width: '100%',
        backgroundColor: theme.palette.type === 'light' ? 'rgba(255, 255, 255, 0.85)' : 'rgba(33, 33, 33, 0.75)'
    },
    legends: {
        flex: 1,
        border: '0 !important',
    },
    chartLegend: {
        // paddingLeft: 40,
    },
    badgeLegend: {
        '& .MuiBadge-badge': {
            transform: 'initial !important',
            top: 2,
            left: 2,
            backgroundColor: colors.grey[500],
            color: theme.palette.getContrastText(colors.grey[700]),

        },
        '&.black .MuiBadge-badge': {
            backgroundColor: colors.grey[800],
            color: theme.palette.getContrastText(colors.grey[900]),
        },
        // Mesma paleta do gauge de horas (Chart/utils.js): verde/amarelo/vermelho
        // são o mesmo semáforo ok/atenção/alerta, então reaproveitam as mesmas cores.
        '&.green .MuiBadge-badge': {
            backgroundColor: '#2D9B52',
            color: theme.palette.getContrastText('#2D9B52'),
        },
        '&.yellow .MuiBadge-badge': {
            backgroundColor: '#ffee58',
            color: theme.palette.getContrastText('#ffee58'),
        },
        '&.red .MuiBadge-badge': {
            backgroundColor: '#D92D20',
            color: theme.palette.getContrastText('#D92D20'),
        }
    }
});